/**
 * 交通 路口百分比报表
 * zxw
 * 2024-01-21
 */
import React, { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import CNF from '../../incs/Config.js';
import { NumberFormat2F } from '../../incs/FunHelper.js'

const TeiiIntersectionPercent = (props) => {
    const [data, setData] = useState([]);

    useEffect(()=>{
        if (props.data) setData(props.data);
    }, [props]);

    useEffect(()=>{
        const chart = new Chart({
            container: props.container ? props.container : 'antv-g2-id',
            autoFit: props.isMobileDevice ? true : false,
        });

        chart.title({
            title: props.title,
            subtitle: props.subtitle,
        });
        chart.data(data);
        chart.coordinate({ type: 'theta', outerRadius: 0.8 });
        chart
            .interval()
            .transform({ type: 'stackY' })
            .encode('y', 'percent')
            .encode('color', 'type')
            .legend('color', { position: 'top', layout: { justifyContent: 'left' } })
            .animate('enter', { 
                type: 'waveIn',
                duration: 1000,
            })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .label({
                position: props.isMobileDevice ? 'inside' : 'spider',
                text: (data) => `${data.type}: ${NumberFormat2F(data.percent)}%`,
            })
            .tooltip((data) => ({
                name: data.type,
                value: `${NumberFormat2F(data.percent)}%`,
            }));
        chart.render();

        return ()=>{
            chart.destroy();
        }
    },[data]);

    return <div id='antv-g2-id'></div>
}

export default TeiiIntersectionPercent;